'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const Nag = require('od-modules/ui/nag/nag');

module.exports = createWidgetFactory({
    name: 'membership_resident_nag',
    viewClass: withRenderedMain(BaseView.extend({})),
    methods: {
        showResidentNag: function({name, fullName}) {
            const translations = {
                title: Odigeo.Utils.replaceCmsKeyArgs(this.keys.primeResidentNotMatchingNamesTitle, name),
                subtitle: Odigeo.Utils.replaceCmsKeyArgs(this.keys.primeResidentNotMatchingNamesSubtitle, fullName),
                button: this.keys.primeResidentNotMatchingNamesButton,
            };
            this.nag = new Nag({
                template: this.templates.membershipResidentNag,
                doNotShowIfSameNagClassAlreadyShown: false,
                showThisInstanceJustOnce: false,
                translations,
            });
            this.nag.show(Nag.NAG_TYPE.continuance);
        },
    },
});
